
import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Popover,
    Button,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AccountCircle from "@mui/icons-material/AccountCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {useTheme, styled} from '@mui/material/styles';
import {FilterModel} from '../../models/modelsFilter';
import { DateField } from "@mui/x-date-pickers/DateField";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { MonthCalendar } from '@mui/x-date-pickers/MonthCalendar';
import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {PickersDay, PickersDayProps}  from '@mui/x-date-pickers/PickersDay';
import {Dayjs} from 'dayjs';
import dayjs from 'dayjs';


export const CharFilterComponent: React.FC<{
  filter: FilterModel,
  onChange: (value: string, filter: FilterModel) => void,
}> = ( {
  filter,
  onChange
}) => {

  const initValue = () => {
    if(filter.value.data === undefined) return ''
    if(filter.value.data === null) return ''
    return filter.value.data
  }

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<string>(initValue());

  const handleChange = (text: string) => {
    setValue(text)
  }

  const submitFilter = () => {
    onChange(value, filter)
  }


  return (

      <TextField
         disabled={false}
         multiline={false}
         rows={1}
         required={true}
         size="small"
         label={filter.label}
         variant="filled"
         value={value}
         onChange={(event) => handleChange(event.target.value)}
         InputProps={{
           disableUnderline: true,
           endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => submitFilter()}>
                  <CheckCircleIcon />
                </IconButton>
              </InputAdornment>
         ),
         }}

      />
    );

};
